<script lang="ts">
  import { Icon } from '@shared/ui/icon';
  import { Wallet } from '@entities/wallet';
  import { useDisconnect } from '@do/svelte-web3-manager';

  const disconnectWallet = useDisconnect();
</script>

<section>
  <div class="mb-5">
    <Wallet />
  </div>

  <button on:click="{disconnectWallet}" class="flex items-center gap-2 py-1.5 text-base font-medium uppercase">
    <Icon name="signOut" />

    Sign out
  </button>
</section>
